'use strict';
angular.module('schoolLinqApp').directive('accountMask', [
	'$filter',
	'$browser',
	'$timeout',
	function ($filter, $browser, $timeout) {
		return {
			scope: {
				accountMask: '=',
				debounceWait: '@',
				changeCallback: '&',
				trigger: '@focus',
			},
			require: 'ngModel',
			restrict: 'A',
			link: function ($scope, $element, $attrs, ngModelCtrl) {
				var mask = '';

				$scope.$watch('accountMask', function (value) {
					//If the account mask is loaded via AJAX, watch for when it changes.
					if (typeof value != 'undefined' && value != null) {
						// replace the 0's in the passed in Mask with _'s for display purposes
						mask = $scope.accountMask.replace(/0/g, '_').split('');
						$element[0].placeholder = mask.join('');
						let newValue = applyMask($element.val());
						$element.val(newValue);

						// only set maskComplete Validity if NOT picking from a list.
						if (!$attrs.uibTypeahead) {
							let isMaskComplete = newValue ? newValue.indexOf('_') < 0 : true;
							ngModelCtrl.$setValidity('maskComplete', isMaskComplete);
						}
					}
				});

				$scope.$watch('trigger', function (value) {
					if (value === 'true') {
						$timeout(function () {
							$element.focus();
						});
					}
				});

				var applyMask = function (data) {
					//If there is no mask then there is nothing to do.
					if (mask.length === 0) return data;

					//This function takes the value of the textbox (data) and applies
					//the defined mask to it. The mask is a character array.

					//This represents how much of the data string that has been applied to the mask so far.
					var charIndex = 0;

					//Remove any mask characters (_ and .) from the data so we only have typed characters.
					//Also eliminate all non-alphanumeric characters.
					data = data
						.replace(/_/g, '')
						.replace(/[.]/g, '')
						.replace(/[^?0-9a-zA-Z]/g, '');

					//Loop through the characters in the mask.
					var maskedValue = mask
						.map(function (char) {
							var returnChar = '';

							//Assign the current mask character and current data character.
							var maskChar = char;
							var dataChar = '';
							if (data.length > charIndex) {
								dataChar = data[charIndex];
							}

							//If the mask character isn't an underscore, we keep the mask.
							if (maskChar !== '_') {
								returnChar = maskChar;
							} else {
								//If we have a data character, use it and increment the data consumed count.
								if (dataChar !== '') {
									returnChar = dataChar;
									charIndex++;
								} else {
									//Otherwise use the mask character.
									returnChar = char;
								}
							}

							return returnChar;
						})
						.join('');

					if (maskedValue === mask.join('') && !$attrs.uibTypeahead) {
						maskedValue = null;
					}
					return maskedValue;
				};

				var listener = function () {
					let selectionStart = $element[0].selectionStart;
					let selectionEnd = $element[0].selectionEnd;
					let skipDot = 0;

					let isValidInput = false;
					// valid input is 0-9
					if (!$element[0].shiftKey && 48 <= $element[0].lastKeyCode && $element[0].lastKeyCode <= 57) {
						isValidInput = true;
					}
					// valid input is 0-9 (on NumPad)
					if (96 <= $element[0].lastKeyCode && $element[0].lastKeyCode <= 105) {
						isValidInput = true;
					}
					// valid input is a-z
					if (!$element[0].shiftKey && 65 <= $element[0].lastKeyCode && $element[0].lastKeyCode <= 90) {
						isValidInput = true;
					}
					// valid input is A-Z
					if ($element[0].shiftKey && 65 <= $element[0].lastKeyCode && $element[0].lastKeyCode <= 90) {
						isValidInput = true;
					}
					// valid input is ?
					if ($element[0].lastKeyCode === 191) {
						isValidInput = true;
					}

					var newValue = applyMask($element.val());
					$element.val(newValue);

					// only set maskComplete Validity if NOT picking from a list.
					if (!$attrs.uibTypeahead) {
						let isMaskComplete = newValue ? newValue.indexOf('_') < 0 : true;
						ngModelCtrl.$setValidity('maskComplete', isMaskComplete);
					}

					// if the last key pressed was the tab key then don't reposition the cursor
					// because doing so causes problems for IE browsers (ie. they won't move the
					// cursor to the next element on the form).
					if ($element[0].lastKeyCode != 9) {
						if (isValidInput) {
							// if the previous char was a . OR the next char is a . then skip over it.
							if ($element[0].value[selectionEnd - 1] === '.' || $element[0].value[selectionEnd] === '.') skipDot = 1;

							$element[0].selectionStart = selectionStart + skipDot;
							$element[0].selectionEnd = selectionEnd + skipDot;
						} else {
							// if the last key was a backspace or delete or Enter key then we don't need to manually move the cursor back.
							if ($element[0].lastKeyCode === 8 || $element[0].lastKeyCode === 46 || $element[0].lastKeyCode === 13) {
								$element[0].selectionStart = selectionStart;
								$element[0].selectionEnd = selectionEnd;
							}
							// if the last key was a . (110 or 190) and previous char in the mask was a . then we don't need to manually move the cursor back.
							else if (
								($element[0].lastKeyCode === 110 || $element[0].lastKeyCode === 190) &&
								$element[0].value[selectionEnd - 1] === '.'
							) {
								$element[0].selectionStart = selectionStart;
								$element[0].selectionEnd = selectionEnd;
							}
							// if its not valid input (0-9 or ?) then backup the cursor by one since we just ate the invalid key.
							else {
								$element[0].selectionStart = selectionStart - 1;
								$element[0].selectionEnd = selectionEnd - 1;
							}
						}
					}

					if ($scope.changeCallback) {
						_.debounce($scope.changeCallback(), $scope.debounceWait ? $scope.debounceWait : 0);
					}
				};

				// This runs when we update the text field
				ngModelCtrl.$parsers.push(function (viewValue) {
					let newValue = applyMask(viewValue);
					// only set maskComplete Validity if NOT picking from a list.
					if (!$attrs.uibTypeahead) {
						let isMaskComplete = newValue ? newValue.indexOf('_') < 0 : true;
						ngModelCtrl.$setValidity('maskComplete', isMaskComplete);
					}
					return newValue;
				});

				// This runs when the model gets updated on the scope directly and keeps our view in sync
				ngModelCtrl.$render = function () {
					// handle case where a new account is selected; make sure old values don't get used.
					if (!ngModelCtrl.$viewValue) {
						$element.val(applyMask(''));
					}

					// only do this if the user is picking from a list or an intial value is being set (like for Dup Account).
					if (ngModelCtrl.$viewValue && ($attrs.uibTypeahead || ngModelCtrl.$viewValue.indexOf('.') > 0)) {
						$element.val(ngModelCtrl.$viewValue);
					}
					// this will handle the case where the value is being set directly by some javascript code.
					else if (ngModelCtrl.$viewValue && ngModelCtrl.$viewValue === ngModelCtrl.$$rawModelValue) {
						$element.val(applyMask(ngModelCtrl.$viewValue));
					}
				};

				$element.bind('change', listener);
				$element.bind('keydown', function (event) {
					var keyCode = event.keyCode;
					// save these values off for use later in the listener function.
					this.lastKeyCode = keyCode;
					this.shiftKey = event.shiftKey;

					// If the keys include the INSERT, CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
					// This lets us support copy and paste too
					if (keyCode === 45 || keyCode === 91 || (15 < keyCode && keyCode < 19) || (33 <= keyCode && keyCode <= 40)) {
						return;
					}
					$browser.defer(listener); // Have to do this or changes don't get picked up properly
				});

				$element.bind('paste cut', function () {
					$browser.defer(listener);
				});
			},
		};
	},
]);
